import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import AmendAcuDeviceProvider from "./baseProviders/amendAcuDeviceProvider"
import useStartNewAcuDeviceAmendment from "../../../../../services/middleware/hooks/devices/lct/useStartNewAcuDeviceAmendment"

interface INewAcuDeviceAmendmentFormUrlParams {
    deviceRef: string
}

interface INewAcuDeviceAmendmentProviderProps {
    children: ReactNode
}

const NewAcuDeviceAmendmentProvider = ({
    children,
}: INewAcuDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewAcuDeviceAmendmentFormUrlParams
    >() as INewAcuDeviceAmendmentFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data,
        setData,
        isLoading,
        error: newAcuDeviceAmendmentError,
    } = useStartNewAcuDeviceAmendment(urlDeviceRef, attachmentUUID)

    return (
        <AmendAcuDeviceProvider
            formData={data}
            setFormData={setData}
            formDataIsLoading={isLoading}
            formDataError={newAcuDeviceAmendmentError}
            attachmentUUID={attachmentUUID}
            systemReference={urlDeviceRef}
        >
            {children}
        </AmendAcuDeviceProvider>
    )
}

export default NewAcuDeviceAmendmentProvider
